import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge needs to know the custom radius rung so that
 * `cn("rounded-control", "rounded-md")` resolves to the latter.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ["control", "xs"],
    },
  },
});

/** Compose class names, letting later Tailwind utilities win over earlier ones. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
